module.exports = __webpack_public_path__ + "img/formulas.962972bd.svg";